export default "__VITE_ASSET__BwroAJqr__"